import PropTypes from "prop-types";
import Category from "./components/category";
import Item from "./components/item";
import styles from "./styles";
import { TITLES } from "../constant";

export default function App({ data, defaultLanguage }) {
  const title = TITLES[defaultLanguage] || "Sitemap";

  return (
    <div className={styles.appLayout}>
      <h1 className={styles.header}>{title}</h1>
      <ul className={styles.mainList}>
        {data.map((category, index) => {
          return <Category key={index} {...category} />;
        })}
      </ul>
    </div>
  );
}

App.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string,
      list: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
          text: PropTypes.string,
        })
      ),
    })
  ),
  defaultLanguage: PropTypes.string,
};
